<template>
    <nav v-if="$store.state.quizView" class="transition-opacity duration-[.5s] delay-[1s]"
        :class="$store.state.quizView && !$store.state.resultView ? 'opacity-[1]' : 'opacity-[0]'">
        <div class="flex gap-[10px]">
            <button @click="$store.commit('prev')" :disabled="first()"
                :class="first() ? 'pointer-events-none border-grey' : 'border-black'"
                class="h-[40px] w-[40px] flex items-center justify-center text-[20px] border relative transition-colors hover:border-violet-700 hover:z-[1] hover:text-violet-700 disabled:pointer-events-none">
                <font-awesome-icon 
                    :class="first() ? 'text-grey' : 'text-black'"
                    icon="fa-regular fa-arrow-left" />
            </button>
            <button @click="$store.commit('next')"
                :disabled="$store.state.progress >= ($store.state.answers.length) || $store.state.progress + 1 > $store.state.total"
                :class="next() ? 'border-black' : 'border-grey'"
                class="h-[40px] w-[40px] flex items-center justify-center text-[20px] border relative transition-colors hover:border-violet-700 hover:z-[1] hover:text-violet-700 disabled:pointer-events-none">
                <font-awesome-icon
                    :class="next() ? 'text-black' : 'text-grey'"
                    icon="fa-regular fa-arrow-right" />
            </button>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'NavigationComponent',
    methods: {
        first() {
            return this.$store.state.progress === 0;
        },

        next() {
            return this.$store.state.progress < this.$store.state.answers.length
        },
    }
}
</script>